module.exports = __webpack_public_path__ + "media/images/icons/flags/NA-4ff6eedf2c4aea10a26b9b7f1c83de0a.svg";